import { useRef, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import { MessageCard } from "./message-card";
import { LoadingMessage } from "./loading-message";
import { REQUEST_STATUS } from "../../../shared/consts";
import { ChatIntro } from "../../chat-intro";
import { useChatContext } from "../../chat";

export const MessagesList = () => {
  const { messages, requestStatus, handleSend, requestReportStatus } =
    useChatContext();
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  return (
    <Paper
      sx={{
        p: 2,
        flex: 1,
        overflowY: "auto",
      }}
    >
      {messages.length === 0 ? (
        <ChatIntro handleSend={handleSend} />
      ) : (
        <List>
          {messages.map((message, index) => (
            <ListItem
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <MessageCard message={message} />
            </ListItem>
          ))}
          {requestStatus === REQUEST_STATUS.LOADING && (
            <LoadingMessage text={"Generating response..."} />
          )}
          {requestReportStatus === REQUEST_STATUS.LOADING && (
            <LoadingMessage text={"Searching for relevant reports..."} />
          )}
          {/* Dummy div that acts as an auto-scroll target */}
          <div ref={messagesEndRef} />
        </List>
      )}
    </Paper>
  );
};
